import CloseButton from "src/components/button/close-button";
import Text from "src/components/text/text";
import { useNavigationStore } from "src/store/navigationStore";
import { useNavigate } from "react-router-dom";
import { useAppStore } from "@/store/appStore";
import { ShareButton } from "@/components/button/share-button";
import ImageButton from "@/components/button/image-button";
import Image from "@/components/image";
import { useEffect, useState } from "react";
import ItemSelector from "@/components/selector/item-selector";
// import { getVenueModelConfig } from "@/const/venue_model/venue_model_config";
import {
  getVenueIdByVenueCode,
  getVenueModelConfigByVenueId,
  getVenueModelConfigByVenueCode,
} from "src/utils/map-util";
import { useExplorationStore } from "@/store/explorationStore";

export default function ExplorationHeader({
  venueCode,
}: {
  venueCode: string;
}) {
  // const setConversationId = useNavigationStore(
  //   (state) => state.setConversationId,
  // );
  const setChatType = useAppStore((state) => state.setChatType);
  const prevChatType = useExplorationStore((state) => state.prevChatType);

  let navigate = useNavigate();
  const [showFloorSelector, setShowFloorSelector] = useState(false);
  const [currentFloor, setCurrentFloor] = useState("LG");
  const [floorSelectionList, setFloorSelectionList] = useState<string[]>([]);
  const setExplorationCameraMode = useExplorationStore(
    (state) => state.setExplorationCameraMode,
  );
  const setCurrentLevel = useExplorationStore((state) => state.setCurrentLevel);
  const clearData = useExplorationStore((state) => state.clearData);

  const triggerResetPositionRotationEvent = useExplorationStore(
    (state) => state.triggerResetPositionRotationEvent,
  );

  const triggerLeaveVenue = useExplorationStore(
    (state) => state.triggerLeaveVenue,
  );

  useEffect(() => {
    // console.log("header venueCode", venueCode);
    // const modelData = getModelSplatData(venueCode);
    // setFloorSelectionList(modelData.floorLevel);
    // if (modelData.floorLevel.length > 0) {
    //   setCurrentFloor(modelData.defaultFloor);
    // }
    const venueData = getVenueModelConfigByVenueCode(venueCode);
    if (venueData?.floor) {
      const floorlist = venueData.floor.map((f) => f.name);
      if (floorlist) {
        setFloorSelectionList(floorlist);
        if (floorlist.length > 0) {
          const defaultFloor = venueData?.floor.find(
            (f) => f.index === venueData?.defaultFloorIndex,
          );
          setCurrentFloor(defaultFloor?.name ?? floorlist[0]);
        }
      }
    }
  }, [venueCode]);

  const resetChat = () => {
    // setConversationId("");
    // reset previous chat type so that home chat will not highlight "exploration" tab
    setChatType(prevChatType);
    clearData();
    leaveVenue();
  };

  const leaveVenue = () => {
    triggerLeaveVenue();
    setTimeout(() => {
      navigate(`/explore/${venueCode}`);
    }, 2000);
  };

  const onResetCamera = () => {
    triggerResetPositionRotationEvent();
    //setResetCameraPosition(!resetCameraPosition);
    // setExplorationCameraMode(1);
  };

  const onChangeFloor = (value: string) => {
    setShowFloorSelector(false);
    setCurrentFloor(value);
    console.log("floor level changed", value);
    setCurrentLevel(value);
  };

  const FloorSelector = () => {
    return (
      <ItemSelector
        isOpen={showFloorSelector}
        onSelect={(value) => {
          onChangeFloor(value);
        }}
        selectionList={floorSelectionList}
        currentValue={currentFloor}
      />
    );
  };

  return (
    <>
      <div className="flex w-full justify-end items-center px-[20px] pt-[20px]">
        <button
          className="flex bg-glass floor-indicator items-center justify-between"
          onClick={() => setShowFloorSelector(true)}
        >
          <Text text={currentFloor} className=" text-500" />
          <Image
            src="/assets/icon_joystick_down.png"
            alt="Clock icon"
            width={24}
            height={24}
          />
        </button>
        <div className="flex w-full justify-end z-50 gap-4">
          <ImageButton
            className="button-glass"
            src="/assets/icon_reset_camera.png"
            onClick={() => onResetCamera()}
            alt="rotate icon"
            size={24}
          />
          <div>
            <ShareButton />
          </div>
          <CloseButton
            goBack={false}
            onClick={() => resetChat()}
            withGlassBg={true}
          />
        </div>
        {<FloorSelector />}
      </div>
    </>
  );
}
